import type { MailboxInfo } from 'owa-client-types';
import type { ReadOnlyAccountConfiguration } from '../store/schema/OwaSessionStore';
import { getAccountSettingsInternal } from '../utils/getAccountSettingsInternal';
import { makeEmptyAccountConfiguration } from '../utils/makeEmptyAccountConfiguration';

export const getAccountScopeUserSettings = (
    mailboxInfo: MailboxInfo
): ReadOnlyAccountConfiguration =>
    getAccountSettingsInternal(mailboxInfo) ?? makeEmptyAccountConfiguration();
